module.exports = __webpack_public_path__ + "img/DIM.024df341.jpg";